<div class="footer">
    <div class="copyright">
       <p>Copyright © Developed by <a href="#" target="_blank">{{companyName}}</a> <span class="current-year"> {{currentYear}} </span></p>
    </div>
  </div>